module.exports = __webpack_public_path__ + "static/img/home_new10.e7b3c6a2.jpg";